import { render, staticRenderFns } from "./RebuildSPUModal.vue?vue&type=template&id=013b3460&scoped=true"
import script from "./RebuildSPUModal.vue?vue&type=script&lang=ts"
export * from "./RebuildSPUModal.vue?vue&type=script&lang=ts"
import style0 from "./RebuildSPUModal.vue?vue&type=style&index=0&id=013b3460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b3460",
  null
  
)

export default component.exports